var Form = function () {

    this.init = function () {

        this.validate();
    }

    this.validate = function () {

        $("#signupForm").validate({
            rules: {
                name: "required",
                email: {
                    required: true,
                    email: true
                },
                cel1: "required",
                cel2: "required",
                message: "required"
            },
            errorPlacement: function (error, element) {
                return true;
            },
            submitHandler: function (form) {

                $("#signupForm").find(".btn").prop('disabled', true);
                
                var ComponentID = $(form).parents(".talk-specialist-main").data("id");

                var TalkSpecialist = {
                    "FullName": $(form).find("#name2").val(),
                    "Company": $(form).find("#company2").val(),
                    "Email": $(form).find("#email2").val(),
                    "Telephone": "(" + $(form).find(".tel1").val() + ") " + $(form).find(".tel2").val(),
                    "NewCustomer": $(form).find("input[name='opcoes']:checked").val(),
                    "Message": $(form).find("#message").val()
                };

                $.ajax({
                    type: "POST",
                    url: "/umbraco/surface/TalkSpecialist/Submit",
                    data: JSON.stringify({ "TalkSpecialist": TalkSpecialist, "ComponentID": ComponentID }),
                    dataType: "json",
                    async: true,
                    contentType: "application/json; charset=utf-8",
                    success: function success(response) {

                        $("#signupForm").each(function () {
                            this.reset();
                        });

                        $("html, body").animate({ scrollTop: 0 }, "slow");

                        if (response) {
                            $("#confirmation-modal").find(".title").text("Enviado com sucesso!");
                        }
                        else {
                            $("#confirmation-modal").find(".title").text("Falha ao enviar.");
                        }
                    },
                    error: function error(e) {
                        $("#confirmation-modal").find(".title").text("Falha ao enviar.");
                    },
                    complete: function () {
                        $("#signupForm").find(".btn").prop('disabled', false);
                        $("#confirmation-modal").open();
                    }
                });
            }
        });
    }

    return this.init();
}